import React from "react";
import "./styles/confirm-dialog.css";

const ConfirmDialog = ({
  show,
  title = "Confirmação",
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
}) => {
  if (!show) return null;

  return (
    <div className="confirm-overlay">
      <div className="confirm-modal">
        <h5 className="confirm-title">{title}</h5>

        <p className="confirm-message">{message}</p>

        <div className="confirm-actions">
          <button className="btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>

          <button className="btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
